import { cssVar, defineStyle, defineStyleConfig } from '@chakra-ui/react';

const baseStyle = defineStyle({
  [cssVar('skeleton-start-color').variable]: 'colors.grey.50',
  [cssVar('skeleton-end-color').variable]: 'colors.grey.100',
  borderRadius: 'xl',
});

export const styleConfig = defineStyleConfig({
  baseStyle,
});
